import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import translations from '../translations';

import logo_aruba from '../assets/vendors/logo_aruba.svg';
import logo_avaya from '../assets/vendors/logo_avaya.svg';
import logo_aws from '../assets/vendors/logo_aws.svg';
import logo_beyondtrust from '../assets/vendors/logo_beyondtrust.svg';
import logo_cisco from '../assets/vendors/logo_cisco.svg';
import logo_cradlepoint from '../assets/vendors/logo_cradlepoint.svg';
import logo_crowdstrike from '../assets/vendors/logo_crowdstrike.svg';
import logo_everpure from '../assets/vendors/logo_everpure.svg';
import logo_extreme from '../assets/vendors/logo_extreme.svg';
import logo_f5 from '../assets/vendors/logo_f5.svg';
import logo_infoblox from '../assets/vendors/logo_infoblox.svg';
import logo_juniper from '../assets/vendors/logo_juniper.svg';
import logo_microsoft from '../assets/vendors/logo_microsoft.svg';
import logo_netapp from '../assets/vendors/logo_netapp.svg';
import logo_netscout from '../assets/vendors/logo_netscout.svg';
import logo_nokia from '../assets/vendors/logo_nokia.svg';
import logo_okta from '../assets/vendors/logo_okta.svg';
import logo_paloalto from '../assets/vendors/logo_paloalto.svg';
import logo_proofpoint from '../assets/vendors/logo_proofpoint.svg';
import logo_ribbon from '../assets/vendors/logo_ribbon.svg';
import logo_ruckus from '../assets/vendors/logo_ruckus.svg';
import logo_splunk from '../assets/vendors/logo_splunk.svg';
import logo_symantec from '../assets/vendors/logo_symantec.svg';
import logo_tenable from '../assets/vendors/logo_tenable.svg';
import logo_trendmicro from '../assets/vendors/logo_trendmicro.svg';
import logo_vectra from '../assets/vendors/logo_vectra.svg';
import logo_vmware from '../assets/vendors/logo_vmware.svg';
import logo_weblib from '../assets/vendors/logo_weblib.svg';
import logo_zscaler from '../assets/vendors/logo_zscaler.svg';

const vendors = [
  { name: 'Cisco', logo: logo_cisco, url: 'https://www.cisco.com' },
  { name: 'Microsoft', logo: logo_microsoft, url: 'https://www.microsoft.com' },
  { name: 'Palo Alto Networks', logo: logo_paloalto, url: 'https://www.paloaltonetworks.com' },
  { name: 'CrowdStrike', logo: logo_crowdstrike, url: 'https://www.crowdstrike.com' },
  { name: 'NETSCOUT', logo: logo_netscout, url: 'https://www.netscout.com' },
  { name: 'F5', logo: logo_f5, url: 'https://www.f5.com' },
  { name: 'Splunk', logo: logo_splunk, url: 'https://www.splunk.com' },
  { name: 'Okta', logo: logo_okta, url: 'https://www.okta.com' },
  { name: 'Zscaler', logo: logo_zscaler, url: 'https://www.zscaler.com' },
  { name: 'VMware', logo: logo_vmware, url: 'https://www.vmware.com' },
  { name: 'AWS', logo: logo_aws, url: 'https://aws.amazon.com' },
  { name: 'Nokia', logo: logo_nokia, url: 'https://www.nokia.com' },
  { name: 'NetApp', logo: logo_netapp, url: 'https://www.netapp.com' },
  { name: 'HPE Aruba', logo: logo_aruba, url: 'https://www.arubanetworks.com' },
  { name: 'HPE Juniper', logo: logo_juniper, url: 'https://www.juniper.net' },
  { name: 'Trend Micro', logo: logo_trendmicro, url: 'https://www.trendmicro.com' },
  { name: 'Tenable', logo: logo_tenable, url: 'https://www.tenable.com' },
  { name: 'Proofpoint', logo: logo_proofpoint, url: 'https://www.proofpoint.com' },
  { name: 'Symantec', logo: logo_symantec, url: 'https://www.broadcom.com/products/cybersecurity' },
  { name: 'Infoblox', logo: logo_infoblox, url: 'https://www.infoblox.com' },
  { name: 'BeyondTrust', logo: logo_beyondtrust, url: 'https://www.beyondtrust.com' },
  { name: 'Extreme Networks', logo: logo_extreme, url: 'https://www.extremenetworks.com' },
  { name: 'Cradlepoint', logo: logo_cradlepoint, url: 'https://www.cradlepoint.com' },
  { name: 'Ribbon', logo: logo_ribbon, url: 'https://ribboncommunications.com' },
  { name: 'Ruckus', logo: logo_ruckus, url: 'https://www.ruckusnetworks.com' },
  { name: 'Vectra', logo: logo_vectra, url: 'https://www.vectra.ai' },
  { name: 'Avaya', logo: logo_avaya, url: 'https://www.avaya.com' },
  { name: 'Everpure', logo: logo_everpure, url: 'https://www.everpure.com' },
  { name: 'Weblib', logo: logo_weblib, url: 'https://www.weblib.fr' },
];

const Vendors = () => {
  const { lang } = useLanguage();
  const t = translations[lang];
  const isRTL = lang === 'ar';

  return (
    <section className="bg-[#f7f8fa] py-20 md:py-28 px-6" id="vendors" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className={`max-w-6xl mx-auto text-center ${isRTL ? 'font-arabic' : ''}`}>
        <motion.h2
          className="text-[#111820] text-4xl font-bold font-magistral mb-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          {t.vendors_title}
        </motion.h2>
        <div className="w-16 h-1 bg-[#97d700] mx-auto mb-6" />
        <motion.p
          className="text-gray-600 text-base md:text-lg mb-12 md:mb-16 max-w-2xl mx-auto leading-[1.9]"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          {t.vendors_subtitle}
        </motion.p>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
        {vendors.map((vendor, i) => {
            const cardClasses = "bg-white rounded-xl border border-gray-200 p-6 flex items-center justify-center h-28 md:h-32 shadow-sm hover:shadow-md hover:scale-105 transition-all duration-300";
            const motionProps = {
              key: vendor.name,
              className: cardClasses,
              initial: { opacity: 0, y: 20 },
              whileInView: { opacity: 1, y: 0 },
              viewport: { once: true },
              transition: { duration: 0.3, delay: i * 0.02 },
            };
            const inner = (
              <img
                src={vendor.logo}
                alt={`${vendor.name} logo`}
                className="max-h-10 md:max-h-12 max-w-full object-contain"
              />
            );
            return vendor.url ? (
              <motion.a
                {...motionProps}
                href={vendor.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ cursor: 'pointer' }}
              >
                {inner}
              </motion.a>
            ) : (
              <motion.div {...motionProps}>
                {inner}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Vendors;
